var apiUrl = process.env.REACT_APP_API_URL;
// var application_token = process.env.REACT_APP_APPLICATION_TOKEN;
// var password_token = process.env.REACT_APP_PASS_TOKEN;


// Function to get the token
// const getToken = async () => {
//   const tokenData = JSON.parse(localStorage.getItem('tokenData'));
//   const now = new Date().getTime();

//   if (tokenData && now - tokenData.timestamp < 30 * 60 * 1000) {
//     // If the token exists in cache and is not older than 30 minutes
//     return tokenData.token;
//   }

//   try {
//     const response = await fetch(`${apiUrl}Authentication/login`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({
//         application: `${application_token}`,
//         password: password_token
//       })
//     });

//     if (!response.ok) {
//       throw new Error('Failed to fetch token');
//     }

//     const data = await response.json();
//     const token = data.result.token; 
//     // console.log(token);
//     // Save the token and the current timestamp to localStorage
//     localStorage.setItem('tokenData', JSON.stringify({
//       token: token,
//       timestamp: now
//     }));

//     return token;
//   } catch (error) {
//     console.error('Error fetching token:', error);
//     throw error;
//   }
// };

const isTokenExpired = () => {
  const user = JSON.parse(localStorage.getItem('user')) || {};
  if (!user.accessToken || !user.expiresOn) {
    return false; // No hay token, consideramos que está expirado
  }

  const now = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
  return now >= user.expiresOn; // Compara si el token ya caducó
};
const logout = () => {
  localStorage.removeItem('user');
  window.location.href = '/'; // Redirige al login
};


export const fetchData = async (endpoint) => {
  if (isTokenExpired()) {
    logout();
    return;
  }
  let url = `${apiUrl}${endpoint}`;
  // const token = await getToken();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  console.log(user);
  const token = user.accessToken || '';
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': '*/*',
        'Authorization': `Bearer ${token}`
      },
    });
    if (!response.ok) {
      throw new Error(`Error en la solicitud: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};


export const postData = async (endpoint, body) => {
  if (isTokenExpired()) {
    logout();
    return;
  }
  const url = `${apiUrl}${endpoint}`;
  // const token = await getToken();
  // const user = JSON.parse(localStorage.getItem('user')) || {};
  // const userName = user.name || '';
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const token = user.accessToken || '';
  
  const headers = {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${token}`
  };

  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(body)
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};

export const putData = async (endpoint, body) => {
  if (isTokenExpired()) {
    logout();
    return;
  }
  const url = `${apiUrl}${endpoint}`;
  // const token = await getToken();
  // const user = JSON.parse(localStorage.getItem('user')) || {};
  // const userName = user.name || '';
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user.accessToken || '';

  const headers = {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${token}`
  };

  
 if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  try {
    const response = await fetch(url, {
      method: 'PUT',
      headers: headers,
      body: body
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error posting data:', error);
    throw error;
  }
};

export const postDataFile = async (endpoint, formData) => {
  if (isTokenExpired()) {
    logout();
    return;
  }
  const url = `${apiUrl}${endpoint}`;
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user.accessToken || '';
  
  const headers = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: formData,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
};


export const deleteData = async (endpoint) => {
  if (isTokenExpired()) {
    logout();
    return;
  }

  const url = `${apiUrl}${endpoint}`; // Pasando el id en la URL
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const token = user.accessToken || '';

  const headers = {
    'Accept': '*/*',
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: headers,
    });

    if (!response.ok) {
      throw new Error(`Error en la eliminación: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting data:', error);
    throw error;
  }
};
